import { IHRLoginOptions } from "../../lib/ihm";
import type { SessionBackend } from "../../lib/backend";

export abstract class BaseStoreSession<T> {
  abstract currentSession: SessionBackend<T, IHRLoginOptions> | null;

  abstract storeSession<T>(session: SessionBackend<T, IHRLoginOptions>): void;
}
